var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { ApiClient } from '../../api/apiClient';
import { trackBookInspection, trackNoInspectionNotReady, trackRequestAppointment, trackAppointmentConfirmed } from '../../utils/analytics';
import { isDateAvailableForBooking, filterAvailableTimes, validateTimeSlot } from '../../utils/dateUtils';
export var BookingPreferences = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4;
    var isSubmitting = _a.isSubmitting, onLocationChange = _a.onLocationChange, _5 = _a.savedLocation, savedLocation = _5 === void 0 ? '' : _5, onSubmit = _a.onSubmit, _6 = _a.locations, providedLocations = _6 === void 0 ? [] : _6, minPrice = _a.minPrice, maxPrice = _a.maxPrice, userStateId = _a.userStateId;
    var _7 = useState(''), location = _7[0], setLocation = _7[1];
    var _8 = useState(null), selectedDate = _8[0], setSelectedDate = _8[1];
    var _9 = useState(''), selectedTime = _9[0], setSelectedTime = _9[1];
    var _10 = useState([]), availableSlots = _10[0], setAvailableSlots = _10[1];
    var _11 = useState([]), availableTimes = _11[0], setAvailableTimes = _11[1];
    var _12 = useState(providedLocations), locations = _12[0], setLocations = _12[1];
    var _13 = useState(false), isLoading = _13[0], setIsLoading = _13[1];
    var _14 = useState(null), error = _14[0], setError = _14[1];
    var _15 = useState(''), selected = _15[0], setSelected = _15[1];
    var _16 = useState(false), showBookingPreferences = _16[0], setShowBookingPreferences = _16[1];
    var _17 = useState(false), showValidation = _17[0], setShowValidation = _17[1];
    var _18 = useState(false), isBookingSuccess = _18[0], setIsBookingSuccess = _18[1];
    var _19 = useState(false), noInspection = _19[0], setNoInspection = _19[1];
    var _20 = useState(null), submittedDetails = _20[0], setSubmittedDetails = _20[1];
    var _21 = useState(null), selectedLocation = _21[0], setSelectedLocation = _21[1];
    var _22 = useState([]), states = _22[0], setStates = _22[1];
    var _23 = useState(null), userStateName = _23[0], setUserStateName = _23[1];
    var _24 = useState(false), hasNoAvailableSlots = _24[0], setHasNoAvailableSlots = _24[1];
    var handleSelect = function (option) {
        setSelected(option);
    };
    var checkLocationAvailability = function (selectedLoc) {
        if (!selectedLoc || !selectedLoc.schedule) {
            setHasNoAvailableSlots(true);
            return;
        }
        // Step 1: Check if ALL weekdays are disabled
        var days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
        var anyDayEnabled = days.some(function (day) {
            var _a;
            var dayCfg = (_a = selectedLoc.schedule) === null || _a === void 0 ? void 0 : _a[day];
            if (!dayCfg)
                return false;
            return dayCfg.is_enabled === true || dayCfg.is_enabled === '1' || dayCfg.is_enabled === 1;
        });
        if (!anyDayEnabled) {
            // All days are disabled, no appointments available
            setHasNoAvailableSlots(true);
            return;
        }
        // Step 2: Check if any actual dates are available in the next 60 days
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        var maxDate = new Date(today);
        maxDate.setDate(maxDate.getDate() + 60);
        var hasAvailableDate = false;
        var currentDate = new Date(today);
        while (currentDate <= maxDate) {
            // Use the existing filterDates logic
            if (filterDates(new Date(currentDate))) {
                hasAvailableDate = true;
                break;
            }
            currentDate.setDate(currentDate.getDate() + 1);
        }
        setHasNoAvailableSlots(!hasAvailableDate);
    };
    var handleBookInspection = function () {
        // Track book inspection button click (Step 4)
        trackBookInspection();
        setShowBookingPreferences(true);
    };
    var handleFinalizeWithoutInspection = function () {
        var args_1 = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args_1[_i] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([], args_1, true), void 0, function (includeLocation) {
            var locationId, locationName, response, details, err_1;
            if (includeLocation === void 0) { includeLocation = false; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Track "not ready" button click (Step 4_skip)
                        trackNoInspectionNotReady();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        setIsLoading(true);
                        locationId = includeLocation && (selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.id) ? selectedLocation.id : '';
                        locationName = includeLocation && (selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.name) ? selectedLocation.name : '';
                        return [4 /*yield*/, ApiClient.submitOnlineEstimation(locationId, null, '', '', [], minPrice === null || minPrice === void 0 ? void 0 : minPrice.toString(), maxPrice === null || maxPrice === void 0 ? void 0 : maxPrice.toString(), locationName, 1)];
                    case 2:
                        response = _a.sent();
                        if (response.success) {
                            details = {
                                location: locationName,
                                date: null,
                                time: '',
                                contactMethod: ''
                            };
                            setSubmittedDetails(details);
                            setIsBookingSuccess(true);
                            setNoInspection(true);
                            onSubmit(true, details);
                        }
                        else {
                            setError(response.error || 'Failed to submit the details');
                            onSubmit(false);
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        setError('Failed to submit the details');
                        onSubmit(false);
                        return [3 /*break*/, 5];
                    case 4:
                        setIsLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    var handleBack = function () {
        setShowBookingPreferences(false);
        setSelectedDate(null);
        setSelectedTime('');
        setAvailableTimes([]);
    };
    var options = [
        { label: 'Phone', value: 'phone', },
        { label: 'Email', value: 'email' },
        { label: 'SMS', value: 'sms' },
    ];
    useEffect(function () {
        // Always sync with provided locations if they're available
        if (providedLocations.length > 0) {
            setLocations(providedLocations);
        }
    }, [providedLocations]);
    // Separate effect for fetching locations when none are provided
    useEffect(function () {
        // Only fetch if no locations were provided from parent
        if (providedLocations.length > 0) {
            return;
        }
        var fetchLocations = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setIsLoading(true);
                        setError(null);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, ApiClient.fetchAvailableLocations(userStateId !== null && userStateId !== void 0 ? userStateId : undefined)];
                    case 2:
                        response = _a.sent();
                        if (response.success && response.data) {
                            setLocations(response.data);
                        }
                        else {
                            setError(response.error || 'Failed to load locations');
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        err_2 = _a.sent();
                        setError('Failed to fetch locations');
                        return [3 /*break*/, 5];
                    case 4:
                        setIsLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        // Only fetch locations if none were provided
        if (providedLocations.length === 0) {
            fetchLocations();
        }
    }, [providedLocations, userStateId]);
    // Fetch states to map userStateId to StateName for grouping
    useEffect(function () {
        var mounted = true;
        var loadStates = function () { return __awaiter(void 0, void 0, void 0, function () {
            var data, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, ApiClient.fetchStates()];
                    case 1:
                        data = _a.sent();
                        if (!mounted)
                            return [2 /*return*/];
                        setStates(data);
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        loadStates();
        return function () { mounted = false; };
    }, []);
    // Derive user's state name when we have states and userStateId
    useEffect(function () {
        if (!userStateId || states.length === 0) {
            setUserStateName(null);
            return;
        }
        var match = states.find(function (s) { return String(s.StateId) === String(userStateId); });
        setUserStateName(match ? match.StateName : null);
    }, [userStateId, states]);
    // Handle initial savedLocation
    useEffect(function () {
        if (savedLocation && locations.length > 0) {
            // savedLocation is now an ID, so find by ID instead of name
            var locationObj = locations.find(function (loc) { return loc.id === savedLocation; });
            if (locationObj) {
                setLocation(locationObj.id);
                setSelectedLocation({ id: locationObj.id, name: locationObj.name });
            }
        }
    }, [savedLocation, locations]);
    // Update available slots when location changes
    useEffect(function () {
        if (location) {
            var selectedLocation_1 = locations.find(function (loc) { return String(loc.id) === String(location); });
            if (selectedLocation_1) {
                var slots = selectedLocation_1.available_slots.map(function (slot) { return ({
                    date: new Date(slot.date),
                    times: slot.times
                }); });
                setAvailableSlots(slots);
                setSelectedDate(null);
                setSelectedTime('');
                setAvailableTimes([]);
                // Check if location has any available appointment slots
                checkLocationAvailability(selectedLocation_1);
            }
        }
        else {
            setHasNoAvailableSlots(false);
        }
    }, [location, locations]);
    // Update available times when date is selected
    useEffect(function () {
        if (!selectedDate)
            return;
        var selectedLoc = locations.find(function (loc) { return loc.id === location; });
        if (!selectedLoc || !selectedLoc.schedule) {
            setAvailableTimes([]);
            setSelectedTime('');
            return;
        }
        var dayMap = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
        var dayKey = dayMap[selectedDate.getDay()];
        var dayCfg = selectedLoc.schedule[dayKey];
        var isEnabled = !!(dayCfg && (dayCfg.is_enabled === true || dayCfg.is_enabled === '1' || dayCfg.is_enabled === 1));
        if (!isEnabled) {
            setAvailableTimes([]);
            setSelectedTime('');
            return;
        }
        var interval = Math.max(5, Number(selectedLoc.slot_interval_minutes || 60));
        var times = [];
        var _a = (dayCfg.open_time || '09:00').split(':').map(function (n) { return parseInt(n, 10) || 0; }), openH = _a[0], openM = _a[1];
        var _b = (dayCfg.close_time || '17:00').split(':').map(function (n) { return parseInt(n, 10) || 0; }), closeH = _b[0], closeM = _b[1];
        // Calculate the last available slot time (closing time minus interval)
        var lastSlot = new Date(selectedDate);
        lastSlot.setHours(closeH, closeM, 0, 0);
        lastSlot.setMinutes(lastSlot.getMinutes() - interval);
        var start = new Date(selectedDate);
        start.setHours(openH, openM, 0, 0);
        var cursor = new Date(start);
        while (cursor <= lastSlot) {
            var hh = String(cursor.getHours()).padStart(2, '0');
            var mm = String(cursor.getMinutes()).padStart(2, '0');
            times.push("".concat(hh, ":").concat(mm));
            cursor.setMinutes(cursor.getMinutes() + interval);
        }
        // Filter times based on lead time setting and current time in location's timezone
        var leadTimeSetting = selectedLoc.lead_time_setting || 'next_day';
        var filteredTimes = filterAvailableTimes(times, selectedDate, selectedLoc.timezone, leadTimeSetting, interval);
        setAvailableTimes(filteredTimes);
        setSelectedTime('');
    }, [selectedDate, locations, location]);
    var handleLocationChange = function (e) {
        var selectedId = e.target.value;
        if (!selectedId) {
            setLocation('');
            setSelectedLocation(null);
            onLocationChange('');
            return;
        }
        var locationObj = locations.find(function (loc) { return String(loc.id) === String(selectedId); });
        if (locationObj) {
            setLocation(selectedId);
            setSelectedLocation({ id: locationObj.id, name: locationObj.name });
            onLocationChange(locationObj.name); // Keep sending name to parent for backward compatibility
        }
    };
    var handleDateChange = function (date) {
        setSelectedDate(date);
    };
    var handleTimeChange = function (e) {
        setSelectedTime(e.target.value);
    };
    // Filter out dates based on location schedule
    var filterDates = function (date) {
        var selectedLoc = locations.find(function (loc) { return String(loc.id) === String(location); });
        if (!selectedLoc || !selectedLoc.schedule) {
            // If no schedule info, allow weekdays as before
            var dayOfWeek = date.getDay();
            return dayOfWeek !== 0 && dayOfWeek !== 6;
        }
        // Check lead time setting and timezone
        var leadTimeSetting = selectedLoc.lead_time_setting || 'next_day';
        var timezone = selectedLoc.timezone;
        // Check if date meets minimum lead time requirement
        if (!isDateAvailableForBooking(date, timezone, leadTimeSetting)) {
            return false;
        }
        // Blackout check (global/state/location pre-filtered server-side into this location)
        if (Array.isArray(selectedLoc.blackout_dates)) {
            var ymd = "".concat(date.getFullYear(), "-").concat(String(date.getMonth() + 1).padStart(2, '0'), "-").concat(String(date.getDate()).padStart(2, '0'));
            if (selectedLoc.blackout_dates.includes(ymd)) {
                return false;
            }
        }
        var dayMap = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
        var cfg = selectedLoc.schedule[dayMap[date.getDay()]];
        if (!cfg)
            return false;
        var isEnabled = (cfg.is_enabled === true || cfg.is_enabled === '1' || cfg.is_enabled === 1);
        if (!isEnabled)
            return false;
        // For "2 Hours" setting, check if today actually has any available time slots
        // If today has no slots available after applying lead time, don't show it
        if (leadTimeSetting === '2_hours') {
            var today = new Date();
            today.setHours(0, 0, 0, 0);
            var checkDate = new Date(date);
            checkDate.setHours(0, 0, 0, 0);
            // Only do this check for today's date
            if (checkDate.getTime() === today.getTime()) {
                var interval = Math.max(5, Number(selectedLoc.slot_interval_minutes || 60));
                var _a = (cfg.open_time || '09:00').split(':').map(function (n) { return parseInt(n, 10) || 0; }), openH = _a[0], openM = _a[1];
                var _b = (cfg.close_time || '17:00').split(':').map(function (n) { return parseInt(n, 10) || 0; }), closeH = _b[0], closeM = _b[1];
                // Calculate the last available slot time (closing time minus interval)
                var lastSlot = new Date(date);
                lastSlot.setHours(closeH, closeM, 0, 0);
                lastSlot.setMinutes(lastSlot.getMinutes() - interval);
                var start = new Date(date);
                start.setHours(openH, openM, 0, 0);
                // Generate all possible time slots
                var times = [];
                var cursor = new Date(start);
                while (cursor <= lastSlot) {
                    var hh = String(cursor.getHours()).padStart(2, '0');
                    var mm = String(cursor.getMinutes()).padStart(2, '0');
                    times.push("".concat(hh, ":").concat(mm));
                    cursor.setMinutes(cursor.getMinutes() + interval);
                }
                // Filter times based on 2-hour lead time
                var filteredTimes = filterAvailableTimes(times, date, timezone, leadTimeSetting, interval);
                // If no times are available after filtering, don't show this date
                if (filteredTimes.length === 0) {
                    return false;
                }
            }
        }
        return true;
    };
    var handleSubmitClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var selectedLoc, isValid, dayMap, dayKey, dayCfg, interval, times, _a, openH, openM, _b, closeH, closeM, lastSlot, start, cursor, hh, mm, leadTimeSetting, filteredTimes, response, details, err_3;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    setShowValidation(true);
                    if (!selectedLocation || !selectedDate || !selectedTime || !selected) {
                        return [2 /*return*/];
                    }
                    selectedLoc = locations.find(function (loc) { return loc.id === selectedLocation.id; });
                    if (selectedLoc) {
                        isValid = validateTimeSlot(selectedDate, selectedTime, selectedLoc.timezone);
                        if (!isValid) {
                            // Time slot is no longer valid (less than 1 hour away)
                            // Reset the time dropdown to force reselection
                            setSelectedTime('');
                            dayMap = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
                            dayKey = dayMap[selectedDate.getDay()];
                            dayCfg = (_c = selectedLoc.schedule) === null || _c === void 0 ? void 0 : _c[dayKey];
                            if (dayCfg) {
                                interval = Math.max(5, Number(selectedLoc.slot_interval_minutes || 60));
                                times = [];
                                _a = (dayCfg.open_time || '09:00').split(':').map(function (n) { return parseInt(n, 10) || 0; }), openH = _a[0], openM = _a[1];
                                _b = (dayCfg.close_time || '17:00').split(':').map(function (n) { return parseInt(n, 10) || 0; }), closeH = _b[0], closeM = _b[1];
                                lastSlot = new Date(selectedDate);
                                lastSlot.setHours(closeH, closeM, 0, 0);
                                lastSlot.setMinutes(lastSlot.getMinutes() - interval);
                                start = new Date(selectedDate);
                                start.setHours(openH, openM, 0, 0);
                                cursor = new Date(start);
                                while (cursor <= lastSlot) {
                                    hh = String(cursor.getHours()).padStart(2, '0');
                                    mm = String(cursor.getMinutes()).padStart(2, '0');
                                    times.push("".concat(hh, ":").concat(mm));
                                    cursor.setMinutes(cursor.getMinutes() + interval);
                                }
                                leadTimeSetting = selectedLoc.lead_time_setting || 'next_day';
                                filteredTimes = filterAvailableTimes(times, selectedDate, selectedLoc.timezone, leadTimeSetting, interval);
                                setAvailableTimes(filteredTimes);
                            }
                            // Don't proceed with submission
                            return [2 /*return*/];
                        }
                    }
                    // Track request appointment button click (Step 5 - PRIMARY CONVERSION)
                    trackRequestAppointment();
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, 4, 5]);
                    setIsLoading(true);
                    return [4 /*yield*/, ApiClient.submitOnlineEstimation(selectedLocation.id, selectedDate, selectedTime, selected, [], minPrice === null || minPrice === void 0 ? void 0 : minPrice.toString(), maxPrice === null || maxPrice === void 0 ? void 0 : maxPrice.toString(), selectedLocation.name, 0)];
                case 2:
                    response = _d.sent();
                    if (response.success) {
                        details = {
                            location: selectedLocation.name,
                            date: selectedDate,
                            time: selectedTime,
                            contactMethod: selected
                        };
                        setSubmittedDetails(details);
                        setIsBookingSuccess(true);
                        setNoInspection(false);
                        // Track appointment confirmed (Step 5_confirmed)
                        trackAppointmentConfirmed();
                        onSubmit(true, details);
                    }
                    else {
                        setError(response.error || 'Failed to submit booking details');
                        onSubmit(false);
                    }
                    return [3 /*break*/, 5];
                case 3:
                    err_3 = _d.sent();
                    setError('Failed to submit booking details');
                    onSubmit(false);
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var renderSuccessMessage = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (!submittedDetails && !noInspection)
            return null;
        var today = new Date();
        var validUntil = new Date(today);
        validUntil.setDate(validUntil.getDate() + 7);
        // Format as dd/mm/yy
        var day = String(validUntil.getDate()).padStart(2, '0');
        var month = String(validUntil.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        var year = String(validUntil.getFullYear()).slice(-2); // Get last two digits
        var formattedDate = "".concat(day, "/").concat(month, "/").concat(year);
        // Get email from cookie
        var userEmail = ((_b = (_a = window.tiofSettings) === null || _a === void 0 ? void 0 : _a.savedData) === null || _b === void 0 ? void 0 : _b.u_email) || '';
        return (_jsxs("div", { className: "success-message text-center", children: [_jsx("p", { className: "text-center max-900", children: noInspection && (_jsxs(_Fragment, { children: ["No problem, we will email you a copy of this offer with further instructions.", _jsx("br", {}), "Please keep in mind your offer is valid until ", formattedDate, ".", _jsx("br", {}), _jsx("br", {}), _jsx("strong", { children: "An email with your offer will be sent to: " }), _jsx("br", {}), userEmail] })) }), !noInspection && submittedDetails && (_jsxs(_Fragment, { children: [_jsx("h2", { children: ((_e = (_d = (_c = window.tiofSettings) === null || _c === void 0 ? void 0 : _c.i18n) === null || _d === void 0 ? void 0 : _d.estimateAppointment) === null || _e === void 0 ? void 0 : _e.thankYouTitle) || 'Thank You!' }), _jsx("p", { className: "mt-5", children: ((_h = (_g = (_f = window.tiofSettings) === null || _f === void 0 ? void 0 : _f.i18n) === null || _g === void 0 ? void 0 : _g.estimateAppointment) === null || _h === void 0 ? void 0 : _h.thankYouMessage) ||
                                'Your booking request has been submitted successfully. We will contact you shortly to confirm your appointment.' }), _jsxs("p", { className: "contact-method mt-5", children: ["We will contact you via: ", _jsx("strong", { children: submittedDetails.contactMethod.toUpperCase() })] }), _jsxs("p", { className: "booking-details mt-5", children: ["Location: ", _jsx("strong", { children: submittedDetails.location }), _jsx("br", {}), "Date: ", _jsx("strong", { children: (_j = submittedDetails.date) === null || _j === void 0 ? void 0 : _j.toLocaleDateString() }), _jsx("br", {}), "Time: ", _jsx("strong", { children: submittedDetails.time })] })] }))] }));
    };
    return (_jsxs("div", { className: "booking-preferences-form", children: [isBookingSuccess ? (renderSuccessMessage()) : (_jsxs(_Fragment, { children: [_jsx("p", { className: "text-center mt-15", children: ((_d = (_c = (_b = window.tiofSettings) === null || _b === void 0 ? void 0 : _b.i18n) === null || _c === void 0 ? void 0 : _c.estimateAppointment) === null || _d === void 0 ? void 0 : _d.description) ||
                            'To fast track the selling process, book a quick vehicle inspection at one of our convenient locations.' }), _jsxs("div", { className: "form-group full-width text-center max-600", children: [_jsxs("select", { id: "inspection_location", value: location || '', onChange: handleLocationChange, required: true, disabled: isSubmitting || isLoading, className: "max-500", children: [_jsx("option", { value: "", children: ((_g = (_f = (_e = window.tiofSettings) === null || _e === void 0 ? void 0 : _e.i18n) === null || _f === void 0 ? void 0 : _f.estimateAppointment) === null || _g === void 0 ? void 0 : _g.selectLocation) ||
                                            'Select your nearest inspection location' }), (function () {
                                        var _a, _b, _c;
                                        var inState = userStateName
                                            ? locations.filter(function (loc) { return (loc.address || '').toLowerCase() === userStateName.toLowerCase(); })
                                            : locations;
                                        var other = userStateName
                                            ? locations.filter(function (loc) { return (loc.address || '').toLowerCase() !== userStateName.toLowerCase(); })
                                            : [];
                                        return (_jsxs(_Fragment, { children: [inState.map(function (loc) { return (_jsx("option", { value: loc.id, children: loc.name }, loc.id)); }), other.length > 0 && (_jsxs(_Fragment, { children: [_jsxs("option", { disabled: true, children: ["\u2500\u2500\u2500\u2500\u2500\u2500 ", ((_c = (_b = (_a = window.tiofSettings) === null || _a === void 0 ? void 0 : _a.i18n) === null || _b === void 0 ? void 0 : _b.estimateAppointment) === null || _c === void 0 ? void 0 : _c.otherLocations) || 'Other Locations', " \u2500\u2500\u2500\u2500\u2500\u2500"] }), other.map(function (loc) { return (_jsx("option", { value: loc.id, children: loc.name }, loc.id)); })] }))] }));
                                    })()] }), isLoading && _jsx("div", { className: "loading", children: "Loading locations..." })] }), !showBookingPreferences && (_jsxs("div", { className: "form-group text-center mt-50 mb-15 full-width", children: [_jsx("button", { type: "button", className: "button icon-right mr-10 mb-sm-c", onClick: handleBookInspection, disabled: isSubmitting || !location, children: ((_k = (_j = (_h = window.tiofSettings) === null || _h === void 0 ? void 0 : _h.i18n) === null || _j === void 0 ? void 0 : _j.estimateAppointment) === null || _k === void 0 ? void 0 : _k.bookInspection) || 'Book your Inspection' }), _jsx("button", { type: "button", className: "button see-through mb-sm-c", onClick: function () {
                                    if (window.confirm('Are you sure you want to submit without an inspection?')) {
                                        handleFinalizeWithoutInspection();
                                    }
                                }, children: ((_o = (_m = (_l = window.tiofSettings) === null || _l === void 0 ? void 0 : _l.i18n) === null || _m === void 0 ? void 0 : _m.estimateAppointment) === null || _o === void 0 ? void 0 : _o.noBookInspection) || 'EMAIL MY ESTIMATE' })] })), showBookingPreferences && (_jsx("div", { className: "booking-preferences-container pad-top-50", children: hasNoAvailableSlots ? (_jsxs("div", { className: "no-booking-slots", children: [_jsxs("div", { className: "no-appointments-message text-center", children: [_jsx("h3", { className: "text-center max-900", children: "Unfortunately, we don\u2019t have any appointments available at the moment." }), _jsxs("p", { className: "text-center max-900 text-large", children: ["Please fill out our ", _jsx("a", { href: "/contact-us/", target: "_blank", children: "contact form" }), " and one of our team members will be in touch soon. ", _jsx("br", {}), "Alternatively, you can also call us on ", _jsx("a", { href: "tel:1300474777", children: "1300 474 777" }), " or email ", _jsx("a", { href: "mailto:talktous@sellmycar.com.au", children: "talktous@sellmycar.com.au" }), "."] })] }), _jsxs("div", { className: "form-group full-width final-buttons", children: [_jsx("div", { className: "form-group half-width text-right mt-50 mbt-15", children: _jsx("button", { type: "button", className: "button secondary icon-left", onClick: handleBack, disabled: isSubmitting, children: ((_q = (_p = window.tiofSettings) === null || _p === void 0 ? void 0 : _p.i18n) === null || _q === void 0 ? void 0 : _q.previous) || 'Back' }) }), _jsx("div", { className: "form-group half-width mt-50", children: _jsx("button", { type: "button", className: "button", onClick: function () { return handleFinalizeWithoutInspection(true); }, disabled: isLoading, children: ((_t = (_s = (_r = window.tiofSettings) === null || _r === void 0 ? void 0 : _r.i18n) === null || _s === void 0 ? void 0 : _s.estimateAppointment) === null || _t === void 0 ? void 0 : _t.noBookInspection) || 'EMAIL MY ESTIMATE' }) })] })] })) : (_jsxs(_Fragment, { children: [_jsx("h3", { className: "text-center", children: ((_w = (_v = (_u = window.tiofSettings) === null || _u === void 0 ? void 0 : _u.i18n) === null || _v === void 0 ? void 0 : _v.estimateAppointment) === null || _w === void 0 ? void 0 : _w.preferredDateTimeTitle) ||
                                        'Select Your preferred date and time:' }), _jsx("p", { className: "text-center", children: ((_z = (_y = (_x = window.tiofSettings) === null || _x === void 0 ? void 0 : _x.i18n) === null || _y === void 0 ? void 0 : _y.estimateAppointment) === null || _z === void 0 ? void 0 : _z.preferredDateTimeDescription) ||
                                        'Note: Your appointment is not confirmed until someone from our team contacts you to confirm.' }), _jsxs("div", { className: "booking-preferences", children: [_jsxs("div", { className: "form-group half-width mb-full-width", children: [_jsx("label", { htmlFor: "booking_date", children: "Select your preferred date" }), _jsxs("div", { className: "datepicker-wrapper", children: [_jsx(DatePicker, { id: "booking_date", selected: selectedDate, onChange: handleDateChange, filterDate: filterDates, minDate: new Date(), dateFormat: "MMMM d, yyyy", placeholderText: "Select a date", className: "form-control ".concat(showValidation && !selectedDate ? 'error' : ''), disabled: isSubmitting }), _jsx("span", { className: "calendar-icon" })] }), showValidation && !selectedDate && (_jsx("p", { className: "error-message", children: "Please select a date" }))] }), _jsxs("div", { className: "form-group half-width mb-full-width", children: [_jsx("label", { htmlFor: "booking_time", children: "Select your preferred time" }), _jsx("div", { className: "timepicker-wrapper", children: _jsxs("select", { id: "booking_time", value: selectedTime, onChange: handleTimeChange, required: true, disabled: isSubmitting, className: "form-control timepicker ".concat(showValidation && !selectedTime ? 'error' : ''), children: [_jsx("option", { value: "", children: "Select a time" }), availableTimes.map(function (time, index) { return (_jsx("option", { value: time, children: time }, "time-".concat(index))); })] }) }), showValidation && !selectedTime && (_jsx("p", { className: "error-message", children: "Please select a time" }))] }), _jsx("div", { className: "form-group full-width", children: _jsx("label", { children: "How would you like to be contacted?" }) }), options.map(function (opt) { return (_jsx("div", { className: "form-group contact-method", children: _jsx("button", { type: "button", className: "option-button ".concat(selected === opt.value ? 'selected' : ''), onClick: function () { return handleSelect(opt.value); }, children: _jsx("span", { className: opt.label.toLowerCase(), children: opt.label }) }) }, opt.value)); }), showValidation && !selected && (_jsx("div", { className: "form-group full-width", children: _jsx("p", { className: "error-message", children: "Please select how you would like to be contacted" }) })), _jsxs("div", { className: "form-group full-width final-buttons", children: [_jsx("div", { className: "form-group half-width text-right mt-50 mbt-15", children: _jsx("button", { type: "button", className: "button secondary icon-left", onClick: handleBack, disabled: isSubmitting, children: ((_1 = (_0 = window.tiofSettings) === null || _0 === void 0 ? void 0 : _0.i18n) === null || _1 === void 0 ? void 0 : _1.previous) || 'Back' }) }), _jsx("div", { className: "form-group half-width mt-50", children: _jsx("button", { type: "button", className: "button icon-right", onClick: handleSubmitClick, disabled: isSubmitting, children: isSubmitting
                                                            ? 'Submitting...'
                                                            : (((_4 = (_3 = (_2 = window.tiofSettings) === null || _2 === void 0 ? void 0 : _2.i18n) === null || _3 === void 0 ? void 0 : _3.estimateAppointment) === null || _4 === void 0 ? void 0 : _4.requestAppointment) || 'Request Appointment') }) })] })] })] })) })), _jsxs("div", { className: "offer-note pad-top-50", children: ["*Offer is subject to inspection and confirmation of the details you have provided. View ", _jsx("a", { href: "/redbook-terms-conditions/", target: "_blank", children: "Terms and Conditions" }), "."] })] })), error && _jsx("div", { className: "error-message", children: error })] }));
};
